export let decemberUppercase = "pThWE";
export default {decemberUppercase};